// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1QSOO","boxTitle":"Qualiphy_boxTitle__g4Ru_","box":"Qualiphy_box__1OEuG","toggleWrap":"Qualiphy_toggleWrap__31VNN"};